import React, { useContext } from "react";
import { FiLock } from "react-icons/fi";
import { BsFillCaretRightFill, BsFillBookmarkFill, BsArrowLeft } from "react-icons/bs";
// @ts-ignore
import SatNavbar from "../../screens/SatCourse/CoursesScreen";
// @ts-ignore
import UserContext from "../../utils/UserContext";

export interface BookMarkItemData {
  id: string | number;
  title: string;
  videoDuration: string;
  lockStatus: boolean;
  isBookmarked: boolean;
  chapterName?: string;
}

export interface BookMarkProps {
  bookMarkData: BookMarkItemData[];
  isError: string | boolean;
  Error?: string;
  title: string;
  HandleBookMark: (id: string | number, index: number) => void;
  HandleDeleteBookMark: (id: string | number, index: number) => void;
  HandleBookMarkVideo: (item: BookMarkItemData) => void;
  HandleArrow: () => void;
}

const BookMark: React.FC<BookMarkProps> = (props) => {
  const { checkSatNavbar } = useContext<any>(UserContext);
  return (
    <div className="Home-Container">
      {props.isError ? (
        <h1>{props.Error}</h1>
      ) : (
        <div className="home-sub-container">
          {window.innerWidth < 1024 ? (
            <>{checkSatNavbar ? <SatNavbar /> : ""}</>
          ) : (
            <div className="cp-Navbar-container">
              <SatNavbar />
            </div>
          )}

          <div className="main-right-container">
            <div>
              <div className="bookmark-first-section">
                <div
                  className="bookmark-arrow"
                  onClick={() => {
                    props.HandleArrow();
                  }}
                >
                  {" "}
                  <BsArrowLeft size="25px" />
                </div>
                <div className="bookmark-title">{props.title}</div>
              </div>
              <div className="List-panel">
                <div>
                  {props.bookMarkData?.length > 0 ? (
                    props.bookMarkData?.map((item, index) => {
                      return (
                        <div
                          className={
                            item.lockStatus
                              ? "list-item-panel disable-div "
                              : "list-item-panel"
                          }
                          key={item.id}
                        >
                          <div
                            className="list-item-left-section"
                            onClick={() => {
                              props.HandleBookMarkVideo(item);
                            }}
                          >
                            <div
                              className={
                                item.lockStatus
                                  ? "list-item-id-panel list-icon-bg"
                                  : "list-item-id-panel"
                              }
                            >
                              {item.lockStatus ? (
                                <>
                                  <FiLock size="15px" color="#807f7f" />
                                </>
                              ) : (
                                <>
                                  <div className="bs-care-bg">
                                    <BsFillCaretRightFill
                                      size="10px"
                                      color="#ffff"
                                    />
                                  </div>
                                </>
                              )}
                            </div>
                            <div className="list-item-title-panel">
                              <div className="list-item-title-div">
                                <p>{item.title}</p>
                              </div>
                              <div className="list-item-lesson-panel">
                                <p>{item.videoDuration}</p>
                              </div>
                            </div>
                          </div>
                          <div className="list-item-icon-panel">
                            <BsFillBookmarkFill
                              onClick={() => {
                                item.isBookmarked
                                  ? props.HandleDeleteBookMark(item.id, index)
                                  : props.HandleBookMark(item.id, index);
                              }}
                              size="15px"
                              color={
                                item.isBookmarked ? "#A20107" : "#C7C7C7"
                              }
                            />
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <>
                      <div className="book-mark-bs-container">
                        <div className="bookmark-icon">
                          <BsFillBookmarkFill size="15px" color="#A20107" />
                        </div>

                        <div className="bs-bookmark-heading">
                          {" "}
                          No bookmark yet
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(BookMark);
